module.exports = __webpack_public_path__ + "img/pcBanner19.3f87cf36.png";